module.exports = __webpack_public_path__ + "static/media/Briarwood-Village-Bylaws.46552938.pdf";